import { render } from "./PlannoDetail.vue?vue&type=template&id=399ded2f"
import script from "./PlannoDetail.vue?vue&type=script&lang=js"
export * from "./PlannoDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__